import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { MoneyFormatterCustom } from "../../../app/modules/formatters/CustomFormatters";
import {
  MixedWidget4,
  BaseTablesWidget1,
  BaseTablesWidget2,
  CustomersDebtAmountWidget,
  StatsWidget11,
  StatsWidget10,
  ListsWidget8,
  ListsWidget10,
  ListsWidget14,
  AdvanceTablesWidget9,
} from "../widgets";
import { Redirect } from "react-router-dom";

import { shallowEqual, useSelector } from "react-redux";
import { SystemUserUiSettings } from "../../../app/modules/SystemUser/pages/_redux/system-user-childs/SystemUserUiSettings";

function transoformDataToInvoiceStatistics(data) {
  let xAxesLabels = [];
  let overdueDebtData = [];
  let debtData = [];
  let scatterData = data.scatterRows;
  data.rows.forEach((element) => {
    xAxesLabels.unshift(new Date(element.date).toLocaleDateString());
    overdueDebtData.unshift(element.delaySum);
    debtData.unshift(element.openSum);
  });

  return { xAxesLabels, overdueDebtData, debtData, scatterData };
}

function transoformDataToChartsFormat(data) {
  let obj = { series: new Array(), categories: new Array() };

  obj.totalDelayDebtPercentHeadline = "Past due amount (%)";
  obj.totalDelayDebtPercentValue = 0;

  let sumSeries = { name: "Total past due Amount", data: new Array() };
  let delaySeries = { name: "Total receivables", data: new Array() };
  let partialData = data.length > 15 ? data.slice(data.length - 15) : data;

  let customersInDelay = {};
  let customersInDelayCount = 0;

  for (let index = 0; index < partialData.length; index++) {
    let customer = partialData[index].customercode;

    if (partialData[index].customerName != undefined)
      customer = partialData[index].customerName;

    obj.categories.push(customer);

    sumSeries.data.push(partialData[index].customerSum);
    delaySeries.data.push(partialData[index].cutomerDeleySum);

    if (partialData[index].cutomerDeleySum != 0) {
      if (customersInDelay[partialData[index].customercode] == undefined) {
        customersInDelayCount++;
        customersInDelay[partialData[index].customercode] = 1;
      }
    }
  }

  if (obj.categories.length > 0) {
    obj.currency = partialData[0].currency;

    obj.series.push(sumSeries);
    obj.series.push(delaySeries);
    obj.headLine = "Customer Debt";

    obj.totalDebtHeadline = "Total accounts receivables";
    obj.totalDebtValue = partialData
      .map((item) => item.customerSum)
      .reduce((prev, next) => prev + next);

    obj.totalDelayDebtHeadline = "Total past due";
    obj.totalDelayDebtValue = partialData
      .map((item) => item.cutomerDeleySum)
      .reduce((prev, next) => prev + next);

    if (obj.totalDelayDebtValue != 0) {
      obj.totalDelayDebtPercentValue =
        (obj.totalDelayDebtValue / obj.totalDebtValue) * 100;
    }

    obj.invoiceClosingAverageHeadline = "Past due Average (Days)";

    let invoiceClosingTotal = partialData
      .map((item) => item.cutomerCloseInvoicesCountDays)
      .reduce((prev, next) => prev + next);

    let invoiceTotal = partialData
      .map((item) => item.cutomerInvoicesCount)
      .reduce((prev, next) => prev + next);

    let invoiceDelayDaysTotal = partialData
      .map((item) => item.cutomerDeleyDays)
      .reduce((prev, next) => prev + next);

    obj.invoiceClosingAverageValue = invoiceClosingTotal / invoiceTotal;

    obj.invoiceClosingAverageValue = obj.invoiceClosingAverageValue.toLocaleString(
      undefined,
      {
        minimumFractionDigits: 2,
      }
    );

    obj.invoicePaymentDelayAverageHeadline = "Past due delay average (Days)";
    obj.invoicePaymentDelayAverageValue = invoiceDelayDaysTotal / invoiceTotal;

    obj.invoicePaymentDelayAverageValue = obj.invoicePaymentDelayAverageValue.toLocaleString(
      undefined,
      {
        minimumFractionDigits: 2,
      }
    );

    //format

    obj.totalDelayDebtValue = MoneyFormatterCustom(
      obj.totalDelayDebtValue,
      obj.currency
    );

    obj.totalDebtValue = MoneyFormatterCustom(obj.totalDebtValue, obj.currency);

    obj.totalDelayDebtPercentValue = obj.totalDelayDebtPercentValue.toFixed(2);

    obj.totalCustomerInDebtPercentHeadLine = "Customers on past due (%)";
    obj.totalCustomerInDebtPercentValue = (
      (customersInDelayCount / partialData.length) *
      100
    ).toFixed(2);

    // obj.totalCustomerInDebtPercentValue =
    //   obj.totalCustomerInDebtPercentValue.toLocaleString(undefined, {
    //     minimumFractionDigits: 2,
    //   }) + "%";
  }

  return obj;
}

export function Demo3Dashboard() {
  const [customerStatistics, setcustomerStatistics] = useState(null);
  const [invoiceStatistics, setInvoiceStatistics] = useState(null);

  const user = useSelector((state) => state.auth.user, shallowEqual);

  var systemUserUiSettings = new SystemUserUiSettings();
  systemUserUiSettings.Set(user);

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          "customer-statistics/1/100000/cutomerCloseInvoicesCountDaysAvg/desc/null"
      )
      .then((response) => {
        let chartsFormat = transoformDataToChartsFormat(response.data);
        setcustomerStatistics(chartsFormat);
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_BASE_URL + "invoice-statistics")
      .then((response) => {
        let invoiceStatsData = transoformDataToInvoiceStatistics(response.data);
        setInvoiceStatistics(invoiceStatsData);
      })
      .catch((error) => {});
  }, []);

  if (systemUserUiSettings.isCustomer) {
    return (
      <>
        {/* begin::Dashboard */}
        {customerStatistics && customerStatistics.series.length > 0 && (
          <div className="row">
            <div className="col-xl">
              <MixedWidget4
                className="gutter-b card-stretch"
                invoiceStatistics={invoiceStatistics}
                series={customerStatistics.series}
                categories={customerStatistics.categories}
                currency={customerStatistics.currency}
                headLine={customerStatistics.headLine}
                topRightOverall={customerStatistics.totalDebtHeadline}
                topRightOverallValue={customerStatistics.totalDebtValue}
                topRight1OverallHeadLine={
                  customerStatistics.invoicePaymentDelayAverageHeadline
                }
                topRight1OverallValue={
                  customerStatistics.invoicePaymentDelayAverageValue
                }
                topleftOverall={customerStatistics.totalDelayDebtHeadline}
                topleftOverallValue={customerStatistics.totalDelayDebtValue}
                botleftOverall={
                  customerStatistics.totalDelayDebtPercentHeadline
                }
                botleftOverallValue={
                  customerStatistics.totalDelayDebtPercentValue
                }
                botrightOverall={
                  customerStatistics.invoiceClosingAverageHeadline
                }
                botrightOverallValue={
                  customerStatistics.invoiceClosingAverageValue
                }
                botrightExtra={
                  customerStatistics.totalCustomerInDebtPercentHeadLine
                }
                botrightExtraValue={
                  customerStatistics.totalCustomerInDebtPercentValue
                }
              />
            </div>
          </div>
        )}

        {/* begin::Row */}
        <div className="row">
          <div className="col-xl">
            <CustomersDebtAmountWidget className="gutter-b" />
          </div>
        </div>
        {/* end::Row */}

        {/* begin::Row */}
        {/* <div className="row">
          <div className="col-xl-4">
            <div className="row">
              <div className="col-xl-12">
                <StatsWidget11
                  className="gutter-b"
                  symbolShape="circle"
                  baseColor="danger"
                />
              </div>
              <div className="col-xl-12">
                <StatsWidget10
                  className="gutter-b"
                  symbolShape="circle"
                  baseColor="info"
                />
              </div>
            </div>
          </div>
          <div className="col-xl-8">
            <ListsWidget14 className="gutter-b card-stretch" />
          </div>
        </div> */}
        {/* end::Row */}

        {/* begin::Row */}
        {/* <div className="row">
          <div className="col-lg-12 col-xxl-12">
            <AdvanceTablesWidget9 className="card-stretch gutter-b" />
          </div>
        </div> */}
        {/* end::Row */}

        {/* begin::Row */}
        {/* <div className="row">
          <div className="col-xl-6">
            <ListsWidget10 className="card-stretch gutter-b" />
          </div>
          <div className="col-xl-6">
            <BaseTablesWidget1 className="card-stretch gutter-b" />
          </div>
        </div> */}
        {/* end::Row */}

        {/* begin::Row */}
        {/* <div className="row">
          <div className="col-lg-4">
            <ListsWidget8 className="card-stretch gutter-b" />
          </div>
          <div className="col-lg-8">
            <BaseTablesWidget2 className="card-stretch gutter-b" />
          </div>
        </div> */}
        {/* end::Row */}

        {/* end::Dashboard */}
      </>
    );
  } else {
    return <Redirect from="/dashboard" to="/admin-dashboard" />;
  }
}
